import styled from "styled-components";

export const ControlSpan = styled.span`
  display: flex;
`;
